module.exports = __webpack_public_path__ + "static/media/streets@2x.ef4b75a4.png";